import React from 'react'
import { Card, CardContent, CardMedia, Grid } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import itemImg from "../../../assert/whey.jpg"
import vendorImg from "../../../assert/vendor.jpg"
import recept from "../../../assert/recept.jpg"
import po from "../../../assert/po.jpg"
import shipping from "../../../assert/shipping.jpg"
import correction from "../../../assert/correction.jpg"
import inventory from "../../../assert/inventory.png"
import quantity from "../../../assert/quantity.jpg"
import cart_purchase from "../../../assert/cart_purchase.jpg"
import categ from "../../../assert/categ.png"
import warehouse from "../../../assert/warehouse.jpg"
import orders from "../../../assert/orders.jpeg"
import auth from "../../../assert/auth.png"
import error from "../../../assert/error.jpg"
import social from "../../../assert/social.png"
import contact from "../../../assert/contacts.jpg"
import ordering from "../../../assert/automated-ordering.png"
import useRoles from '../../../hooks/useRoles';

import { useHistory } from 'react-router-dom';


const useStyles = makeStyles((theme) => ({

    root: {
        display: 'flex',
        justifyContent: "space-between"
    },

    details: {
        display: 'flex',
        flexDirection: 'column',
    },

    content: {
        flex: '1 0 auto',
        height: "150px",
        textAlign: "center",
        paddingTop: 60,
    },

    cover: {
        width: 151,
    },

    controls: {
        display: 'flex',
        alignItems: 'center',
        paddingLeft: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        height: '90px',
        width: "220px"
    },

    playIcon: {
        height: 38,
        width: 38,
    },

    textstyle: {
        fontWeight: "bold",
        textAlign: "center",
    },

}));


const menuList = [
    { title: "SOCIAL MEDIA ", link: "/publish", image: social, active: true },
    { title: "CONTACTS MANAGE", link: "/contacts", image: contact, active: true },
    { title: "MANAGE VENDORS", link: "/vendor-manager", image: vendorImg, active: true },   
    { title: " CORRECT ITEMS AND VALIDATE", link: "/correction-manager", image: correction, active: true },
    { title: " MANAGE CATEGORIES", link: "/cat-manager", image: categ, active: true },
    { title: "WAREHOUSE MANAGE", link: "/warehouse-manager", image: warehouse, active: true },
    { title: "ORDERS", link: "/orders", image: orders, active: true },
    { title: "VENDOR ORDERS", link: "/v-orders", image: orders, active: true },
    { title: "USER MANAGEMENT", link: "/user-management", image: auth, active: true },
    { title: "ERRORS LOG ", link: "/error-log", image: error, active: true },
    { title: "FAMILY", link: "/family", image: categ, active: true },
    { title: "ITEMS TO PDF", link: "/item-pdf", image: categ, active: true },
    { title: "BARCODES GENERATOR", link: "/barcode", image: categ, active: true },
    { title: " MANAGE P.O", link: "/po-manager", image: po, active: true },
    { title: " MANAGE P.O TOGO", link: "/togo-po-manager", image: po, active: true },
    { title: "NEW PRODUCT TO PURCHASE", link: "/purchasing", image: inventory, active: true },
]
const menutest  = [ 
    { title: "SOCIAL MEDIA ", link: "/publish", image: social, active: true },
    { title: "CONTACTS MANAGE", link: "/contacts", image: contact, active: true },
    { title: "MANAGE ITEMS", link: "/items", image: itemImg, active: true },
    { title: "MANAGE VENDORS", link: "/vendor-manager", image: vendorImg, active: true },
    { title: " MANAGE RECEIVING", link: "/receiving-manager", image: recept, active: true },
    { title: " MANAGE SHIPPING", link: "/shipping-manager", image: shipping, active: true },
    { title: " CORRECT ITEMS AND VALIDATE", link: "/correction-manager", image: correction, active: true },
    { title: " MANAGE CATEGORIES", link: "/cat-manager", image: categ, active: true },
    // { title: " PRODUCT TO PURCHASE", link: "/inventory", image: inventory, active: true },
    { title: " NEW PRODUCT TO PURCHASE", link: "/purchasing", image: inventory, active: true },
    { title: "WAREHOUSE MANAGE", link: "/warehouse-manager", image: warehouse, active: true },
    { title: "ORDERS", link: "/orders", image: orders, active: true },
    { title: "VENDOR ORDERS", link: "/v-orders", image: orders, active: true },
    { title: "USER MANAGEMENT", link: "/user-management", image: auth, active: true },
    { title: "ERRORS LOG ", link: "/error-log", image: error, active: true },
    { title: "FAMILY", link: "/family", image: categ, active: true },
    { title: "ITEMS TO PDF", link: "/item-pdf", image: categ, active: true },
    { title: "BARCODES GENERATOR", link: "/barcode", image: categ, active: true },
    { title: "AUTOMATED ORDERING ", link: "/automated-ordering", image: ordering, active: true },
]

const menuReceiving = [
    { title: " MANAGE RECEIVING", link: "/receiving-manager", image: recept, active: true },   
]

const menuItems = [
    { title: "MANAGE ITEMS", link: "/items", image: itemImg, active: true },   
]
const menuPurchase = [   
    // { title: " PRODUCT TO PURCHASE", link: "/inventory", image: inventory, active: true },
    // { title: " PRODUCT PURCHASING", link: "/purchasing", image: inventory, active: true },
]
const menuPo = [   
    { title: " AUTOMATED ORDERING", link: "/automated-ordering", image: inventory, active: true },
    { title: " ACTIVE POURCHASE", link: "/active-purchase", image: inventory, active: true },
    { title: " QUANTITY FOR MONTH", link: "/quantity-purchase", image: quantity, active: true },
    { title: " PURCHASE CART", link: "/cart-purchase", image: cart_purchase, active: true },
    //{ title: " Manage Orders", link: "/ManageOrders", image: cart_purchase, active: true },
]
const menuShipping = [   
    { title: " MANAGE SHIPPING", link: "/shipping-manager", image: shipping, active: true },
]



export const Home = () => {
    const classes = useStyles();
    const navigation = useHistory();
    const { userRole, isLoading } = useRoles();

    // console.log(userRole)
    // console.log(userRole?.Admin)
    return (
        <div>
            <Grid container item xs={12} spacing={3}>
                {menuList.map((e, i) => (
                    <Grid key={i} item xs={12} sm={4}>
                        <Card elevation={10} className={classes.root}
                              onClick={() => e.active ? navigation.push(e.link)
                                  : alert('En developpement')}>
                            <div className={classes.details}>
                                <CardContent className={classes.content}>
                                    <Typography component="h6" variant="subtitle1" className={classes.textstyle}>
                                        {e.title}
                                    </Typography>
                                </CardContent>
                            </div>
                            <CardMedia
                                className={classes.cover}
                                image={e.image}
                                title={e.title}
                            />
                        </Card>
                    </Grid>
                ))
                }
                 {userRole?.Admin !== true && userRole?.PurchaseReader !== true ? ""
                    :
                    menuPurchase.map((e, i) => (
                        <Grid key={i} item xs={12} sm={4}>
                            <Card elevation={10} className={classes.root}
                                onClick={() => e.active ? navigation.push(e.link)
                                    : alert('En developpement')}>
                                <div className={classes.details}>
                                    <CardContent className={classes.content}>
                                        <Typography component="h6" variant="subtitle1" className={classes.textstyle}>
                                            {e.title}
                                        </Typography>
                                    </CardContent>
                                </div>
                                <CardMedia
                                    className={classes.cover}
                                    image={e.image}
                                    title={e.title}
                                />
                            </Card>
                        </Grid>
                    ))

                }

                {userRole?.Admin !== true && userRole?.ItemReader !== true ? ""
                    :
                    menuItems.map((e, i) => (
                        <Grid key={i} item xs={12} sm={4}>
                            <Card elevation={10} className={classes.root}
                                onClick={() => e.active ? navigation.push(e.link)
                                    : alert('En developpement')}>
                                <div className={classes.details}>
                                    <CardContent className={classes.content}>
                                        <Typography component="h6" variant="subtitle1" className={classes.textstyle}>
                                            {e.title}
                                        </Typography>
                                    </CardContent>
                                </div>
                                <CardMedia
                                    className={classes.cover}
                                    image={e.image}
                                    title={e.title}
                                />
                            </Card>
                        </Grid>
                    ))

                }
                {userRole?.Admin !== true && userRole?.ReceivingReader !== true ? ""
                    :
                    menuReceiving.map((e, i) => (
                        <Grid key={i} item xs={12} sm={4}>
                            <Card elevation={10} className={classes.root}
                                onClick={() => e.active ? navigation.push(e.link)
                                    : alert('En developpement')}>
                                <div className={classes.details}>
                                    <CardContent className={classes.content}>
                                        <Typography component="h6" variant="subtitle1" className={classes.textstyle}>
                                            {e.title}
                                        </Typography>
                                    </CardContent>
                                </div>
                                <CardMedia
                                    className={classes.cover}
                                    image={e.image}
                                    title={e.title}
                                />
                            </Card>
                        </Grid>
                    ))

                }
                {userRole?.Admin !== true &&  userRole?.ShippingReader !== true ? ""
                    :
                    menuShipping.map((e, i) => (
                        <Grid key={i} item xs={12} sm={4}>
                            <Card elevation={10} className={classes.root}
                                onClick={() => e.active ? navigation.push(e.link)
                                    : alert('En developpement')}>
                                <div className={classes.details}>
                                    <CardContent className={classes.content}>
                                        <Typography component="h6" variant="subtitle1" className={classes.textstyle}>
                                            {e.title}
                                        </Typography>
                                    </CardContent>
                                </div>
                                <CardMedia
                                    className={classes.cover}
                                    image={e.image}
                                    title={e.title}
                                />
                            </Card>
                        </Grid>
                    ))

                } 
                {userRole?.Admin !== true &&  userRole?.PurchaseReader !== true ? ""
                    :
                    menuPo.map((e, i) => (
                        <Grid key={i} item xs={12} sm={4}>
                            <Card elevation={10} className={classes.root}
                                onClick={() => e.active ? navigation.push(e.link)
                                    : alert('En developpement')}>
                                <div className={classes.details}>
                                    <CardContent className={classes.content}>
                                        <Typography component="h6" variant="subtitle1" className={classes.textstyle}>
                                            {e.title}
                                        </Typography>
                                    </CardContent>
                                </div>
                                <CardMedia
                                    className={classes.cover}
                                    image={e.image}
                                    title={e.title}
                                />
                            </Card>
                        </Grid>
                    ))

                }

            </Grid>
        </div>
    )
}
